import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  cellContainer: {
    height: 38,
    width: CELL_WIDTHS.VALUE.LARGE,
    minWidth: CELL_WIDTHS.VALUE.LARGE,
  },
  cellExpanded: {
    width: CELL_WIDTHS.VALUE.XXSMALL * 4,
    minWidth: CELL_WIDTHS.VALUE.XXSMALL * 4,
  },
  weekCell: {
    width: CELL_WIDTHS.VALUE.XSMALL,
    minWidth: CELL_WIDTHS.VALUE.XSMALL,
  },
  button: {
    right: 0,
    zIndex: 3,
  },
  buttonOpened: {
    right: -8,
  },
}));

export default useStyle;